import { useQuoteList, useQuoteListForUser } from "../../../../common/hooks/api/quote";

export const useQuotesListByRole = (isAdmin) => isAdmin ? useQuoteList : useQuoteListForUser;
